import { ref, computed } from "vue";
import { defineStore } from "pinia";

export const useStore = defineStore("store", () => {
  const networkVisible = ref(
    sessionStorage.getItem("networkVisible") === "true" ? true : false
  );

  const uploadDirectory = computed(() => `/upload`);

  const nutuiThemeVars = ref({
    primaryColor: "#409eff",
    primaryColorEnd: "#409eff",
    checkboxMarginRight: "5px",
    checkboxLabelMarginLeft: "5px",
    checkboxLabelFontSize: "14px",
  });

  function toggleNetwork() {
    networkVisible.value = !networkVisible.value;
    sessionStorage.setItem("networkVisible", `${networkVisible.value}`);
    return networkVisible.value;
  }
  return {
    networkVisible,
    uploadDirectory,
    nutuiThemeVars,
    toggleNetwork,
  };
});
